import { CmsBrand } from '../store/Entities/CmsBrands/cmsbrands.reducer';
import { CallApiOptions } from './api';

export const cmsBrandFetchCallOptions = (
  cmsBrandId: number
): CallApiOptions => ({
  method: 'GET',
  endpoint: `brands/${cmsBrandId}`,
  params: { include: 'images' },
});

export const cmsBrandSaveCallOptions = (
  cmsBrand: CmsBrand
): CallApiOptions => ({
  method: 'PUT',
  endpoint: `brands/${cmsBrand.id}`,
  body: JSON.stringify({
    ...cmsBrand,
    images: { data: cmsBrand.images },
  }),
});



// WEBPACK FOOTER //
// ./src/services/cmsbrands.services.ts